export default __webpack_public_path__ + "static/media/manageinstitute.a01b7e83.svg";